import {
  AutocompleteInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  NullableBooleanInput,
  ReferenceInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
} from 'react-admin';

export const CommentsEdit = () => (
  <Edit>
    <SimpleForm
      toolbar={
        <Toolbar>
          <SaveButton label="Save" />
        </Toolbar>
      }
    >
      <TextInput source="name" />
      <TextInput multiline fullWidth source="text" />
      <BooleanInput source="visible" />
    </SimpleForm>
  </Edit>
);
